import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/themes";
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/layouts",
      component: Layout,
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("../pages/Dashboard.vue"),
        },
        {
          path: "/search",
          name: "search",
          component: () => import("../pages/Search.vue"),
        },
        {
          path: "/audit",
          name: "audit",
          component: () => import("../pages/Audit.vue"),
        },
        {
          path: "/audit/changes",
          name: "audit-changes",
          component: () => import("../pages/Changes.vue"),
        },
        {
          path: "/audit-log",
          name: "audit-log",
          component: () => import("../pages/AuditLog.vue"),
          meta: { requiresAuth: true, requiresRole: ["Admin", "Auditor"] },
        },
        {
          path: "/admin/users",
          name: "users",
          component: () => import("../pages/admin/Users.vue"),
        },
        {
          path: "/admin/departments",
          name: "departments",
          component: () => import("../pages/admin/Departments.vue"),
        },
        {
          path: "/admin/companies",
          name: "companies",
          component: () => import("../pages/admin/Companies.vue"),
        },
        {
          path: "/admin/contacts",
          name: "contacts",
          component: () => import("../pages/admin/Contacts.vue"),
        },
        {
          path: "/add-user",
          name: "add-user",
          component: () => import("../pages/AddUser.vue"),
        },
        {
          path: "/settings?page=email-settings",
          name: "settings-email-settings",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=security",
          name: "settings-security",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=preferences",
          name: "settings-preferences",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=two-factor-authentication",
          name: "settings-two-factor-authentication",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=device-history",
          name: "settings-device-history",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=notification-settings",
          name: "settings-notification-settings",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=connected-services",
          name: "settings-connected-services",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=social-media-links",
          name: "settings-social-media-links",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings?page=account-deactivation",
          name: "settings-account-deactivation",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/settings",
          name: "settings",
          component: () => import("../pages/Settings.vue"),
        },
        {
          path: "/logging-settings",
          name: "logging-settings",
          component: () => import("../pages/LoggingSettings.vue"),
        },
        {
          path: "/billing",
          name: "billing",
          component: () => import("../pages/Billing.vue"),
        },
        {
          path: "/pricing",
          name: "pricing",
          component: () => import("../pages/Pricing.vue"),
        },
        {
          path: "/categories",
          name: "categories",
          component: () => import("../pages/Categories.vue"),
        },
          {
          path: "/add-service",
          name: "add-service",
          component: () => import("../pages/Services/AddService.vue"),
        },
        {
          path: "/service-list",
          name: "service-list",
          component: () => import("../pages/Services/ServiceList.vue"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { name: 'Services', path: '/service-list', active: true },
            ],
            }
        },
        {
          path: "/services/:id",
          name: "service-detail",
          component: () => import("../pages/Services/Details.vue"),
          props: true,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { name: 'Services', path: '/service-list' },
              { name: 'Service Detail', path: '/services/:id', active: true }
            ],
            }
        },
        {
          path: "/services/:id/edit",
          name: "edit-service",
          component: () => import("../pages/Services/EditService.vue"),
          props: true,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { name: 'Services', path: '/service-list' },
              { name: 'Service Detail', path: '/services/:id' },
              { name: 'Edit', path: '/services/:id/edit', active: true }
            ],
            }
        },
        {
          path: "/services/:id/flows",
          name: "ServiceFlows",
          component: () => import("@/pages/Services/ServiceFlows.vue"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { name: 'Services', path: '/service-list' },
              { name: 'Service Detail', path: '/services/:id' },
              { name: 'Flows', path: '/services/:id/flows', active: true }
            ],
            }
        },
        {
          path: "/service-data-flow",
          name: "service-data-flow",
          component: () => import("../pages/ServiceDataFlow.vue"),
        },
        {
          path: "/flows/:id/dpia",
          name: "FlowDPIA",
          component: () => import("@/views/flows/DPIAView.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/flows/:id",
          name: "FlowDetail",
          component: () => import("@/pages/flows/FlowDetail.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/vendors",
          name: "vendor-list",
          component: () => import("../pages/Vendor/List.vue"),
        },
        {
          path: "/vendors/:id",
          name: "vendor-detail",
          component: () => import("../pages/Vendor/Details.vue"),
          props: true,
        },
        {
          path: "/vendors/add",
          name: "vendor-add",
          component: () => import("../pages/Vendor/Add.vue"),
        },
        {
          path: "/vendors/:id/edit",
          name: "vendor-edit",
          component: () => import("../pages/Vendor/Edit.vue"),
          props: true,
        },
        {
          path: "/risklevels",
          name: "risklevel-list",
          component: () => import("../pages/RiskLevel/List.vue"),
        },
        {
          path: "/risklevels/add",
          name: "risklevel-add",
          component: () => import("../pages/RiskLevel/Add.vue"),
        },
        {
          path: "/risklevels/:id",
          name: "risklevel-detail",
          component: () => import("../pages/RiskLevel/RiskLevelDetails.vue"),
          props: true,
        },
        {
          path: "/risklevels/:id/edit",
          name: "risklevel-edit",
          component: () => import("../pages/RiskLevel/Edit.vue"),
          props: true,
        },
        {
          path: "/statuses",
          name: "status-list",
          component: () => import("../pages/Status/List.vue"),
        },
        {
          path: "/statuses/add",
          name: "status-add",
          component: () => import("../pages/Status/Add.vue"),
        },
        {
          path: "/statuses/:id",
          name: "status-detail",
          component: () => import("../pages/Status/Details.vue"),
          props: true,
        },
        {
          path: "/statuses/:id/edit",
          name: "status-edit",
          component: () => import("../pages/Status/Edit.vue"),
          props: true,
        },
        {
          path: "/piidatatypes",
          name: "piidatatype-list",
          component: () => import("../pages/PiiDataType/List.vue"),
        },
        {
          path: "/piidatatypes/add",
          name: "piidatatype-add",
          component: () => import("../pages/PiiDataType/Add.vue"),
        },
        {
          path: "/piidatatypes/:id",
          name: "piidatatype-detail",
          component: () => import("../pages/PiiDataType/Details.vue"),
          props: true,
        },
        {
          path: "/piidatatypes/:id/edit",
          name: "piidatatype-edit",
          component: () => import("../pages/PiiDataType/Edit.vue"),
          props: true,
        },
        {
          path: "/legalbases",
          name: "legalbasis-list",
          component: () => import("../pages/LegalBasis/List.vue"),
        },
        {
          path: "/legalbases/add",
          name: "legalbasis-add",
          component: () => import("../pages/LegalBasis/Add.vue"),
        },
        {
          path: "/legalbases/:id",
          name: "legalbasis-detail",
          component: () => import("../pages/LegalBasis/Details.vue"),
          props: true,
        },
        {
          path: "/legalbases/:id/edit",
          name: "legalbasis-edit",
          component: () => import("../pages/LegalBasis/Edit.vue"),
          props: true,
        },
        {
          path: "/system-status",
          name: "system-status",
          component: () => import("../pages/SystemStatus.vue"),
        },
        {
          path: "/licenses",
          name: "licenses",
          component: () => import("../pages/Licenses.vue"),
        },
        {
          path: '/admin/processing-purposes',
          name: 'AdminProcessingPurposes',
          component: () => import('@/pages/ProcessingPurposeAdmin.vue'),
          meta: { requiresAuth: true, requiresRole: 'Admin' }
        },
        {
          path: '/admin/retention-policies',
          name: 'AdminRetentionPolicies',
          component: () => import('@/views/admin/RetentionPolicyAdmin.vue'),
          meta: { requiresAuth: true, requiresRole: 'Admin' }
        },
        {
          path: '/admin/data-subject-categories',
          name: 'AdminDataSubjectCategories',
          component: () => import('@/pages/admin/DataSubjectCategoryAdmin.vue'),
          meta: { requiresAuth: true, requiresRole: 'Admin' }
        },
        {
          path: '/admin/pii-data-types',
          name: 'AdminPiiDataTypes',
          component: () => import('@/pages/admin/PiiDataTypeAdmin.vue'),
          meta: { requiresAuth: true, requiresRole: 'Admin' }
        },
        {
          path: '/admin/flow-types',
          name: 'AdminFlowTypes',
          component: () => import('@/views/admin/FlowTypeAdmin.vue'),
          meta: { requiresAuth: true, requiresRole: 'Admin' }
        },
        {
          path: '/admin/services',
          name: 'AdminServices',
          component: () => import('@/pages/admin/ServiceAdmin.vue'),
          meta: { requiresAuth: true, requiresRole: 'Admin' }
        },
      ],
    },
    {
      path: "/",
      name: "landing-page",
      component: () => import("../pages/LandingPage.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../pages/Login.vue"),
    },
    {
      path: "/register",
      name: "register",
      component: () => import("../pages/Register.vue"),
    },
    {
      path: "/confirm-email",
      name: "confirm-email",
      component: () => import("../pages/ConfirmEmail.vue"),
    },
    {
      path: "/verify-magic-link",
      name: "verify-magic-link",
      component: () => import("../pages/VerifyMagicLink.vue"),
    },
    {
      path: "/first-login",
      name: "first-login",
      component: () => import("../pages/FirstLogin.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("../pages/Logout.vue"),
    },
    {
      path: "/for-legal-teams",
      name: "for-legal-teams",
      component: () => import("../pages/Public/ForLegalTeams.vue"),
    },
    {
      path: "/for-product-owners",
      name: "for-product-owners",
      component: () => import("../pages/Public/ForProductOwners.vue"),
    },
    {
      path: "/for-security-teams",
      name: "for-security-teams",
      component: () => import("../pages/Public/ForSecurityTeams.vue"),
    },
    {
      path: "/for-data-protection-officers",
      name: "for-data-protection-officers",
      component: () => import("../pages/Public/ForDataProtectionOfficers.vue"),
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("../pages/Public/Privacy.vue"),
    },
    {
      path: "/terms",
      name: "terms",
      component: () => import("../pages/Public/Terms.vue"),
    },
    {
      path: "/refunds",
      name: "refunds",
      component: () => import("../pages/Public/Refunds.vue"),
    },
    {
      path: "/samples/flow",
      name: "sample-flow",
      component: () => import("../pages/Public/Samples/FlowSample.vue"),
    },
    {
      path: "/samples/dpa-flow",
      name: "sample-dpa-flow",
      component: () => import("../pages/Public/Samples/DPASample.vue"),
    },
    {
      path: "/samples/report",
      name: "sample-report",
      component: () => import("../pages/Public/Samples/ReportSample.vue"),
    },
    {
      path: "/workflows/legal",
      name: "workflows-legal",
      component: () => import("../pages/Public/Workflows/LegalWorkflows.vue"),
    },
    {
      path: "/workflows/product",
      name: "workflows-product",
      component: () => import("../pages/Public/Workflows/ProductWorkflows.vue"),
    },
    {
      path: "/workflows/security",
      name: "workflows-security",
      component: () => import("../pages/Public/Workflows/SecurityWorkflows.vue"),
    },
    {
      path: "/product/tour",
      name: "product-tour",
      component: () => import("../pages/Public/Product/Tour.vue"),
    },
    {
      path: "/demo",
      name: "demo",
      component: () => import("../pages/Public/Demo.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/dashboard",
    },
  ],
});

router.beforeEach((to, _from, next) => {
  const auth = useAuthStore();
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    next({ name: 'login' });
  } else if (
    auth.isAuthenticated &&
    auth.needsSetup &&
    to.name !== 'first-login'
  ) {
    next({ name: 'first-login' });
  } else if (
    to.meta.requiresRole &&
    !(
      Array.isArray(to.meta.requiresRole)
        ? to.meta.requiresRole.includes(auth.user?.role as string)
        : auth.user?.role === to.meta.requiresRole
    )
  ) {
    next({ name: 'dashboard' });
  } else if (
    auth.isAuthenticated &&
    !auth.tenant?.isSetupCompleted &&
    to.name !== 'first-login' &&
    to.name !== 'verify-magic-link' &&
    to.name !== 'confirm-email'
  ) {
    next({ name: 'first-login' });
  } else {
    next();
  }
});

export default router;
